export type DatasetFormStep = 1 | 2;
export type DatasetMethod = "table" | "sql";
export type DatasetKind = "dimension" | "fact";

export const METHOD_OPTIONS: { key: DatasetMethod; label: string }[] = [
  { key: "table", label: "Table" },
  { key: "sql", label: "SQL Query" },
];
